import { useMemo, useState } from "react";
import Reveal from "@/components/base/Reveal";
import { gossipCategories, gossipItems } from "@/mocks/siteContent";

export default function GossipSection() {
  const [active, setActive] = useState("全部");

  const filtered = useMemo(() => {
    if (active === "全部") return gossipItems;
    return gossipItems.filter((item) => item.category === active);
  }, [active]);

  return (
    <section id="gossip" className="scroll-mt-20 w-full bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <Reveal>
          <div className="flex items-center gap-3 mb-3">
            <span className="h-px w-8 bg-primary-500"></span>
            <span className="font-label text-xs md:text-sm tracking-widest text-primary-600 uppercase">
              Gossip
            </span>
          </div>
          <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl">
            八卦黑料与网络热议
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-3xl leading-relaxed">
            把网络上流传较广的说法归类展示，并标注它们属于传闻、热议还是已被澄清。请勿把网传内容当作已证实的事实。
          </p>
        </Reveal>

        {/* filter */}
        <Reveal>
          <div className="mt-8 flex flex-wrap gap-2" role="tablist" aria-label="话题分类筛选">
            {gossipCategories.map((cat) => {
              const on = active === cat;
              return (
                <button
                  key={cat}
                  type="button"
                  role="tab"
                  aria-selected={on}
                  onClick={() => setActive(cat)}
                  className={`px-4 py-2 rounded-full text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap border ${
                    on
                      ? "bg-primary-500 text-background-50 dark:text-foreground-950 border-primary-500"
                      : "bg-background-50 text-foreground-700 border-background-300 hover:border-primary-300 hover:text-primary-600"
                  }`}
                >
                  {cat}
                  <span className="ml-1.5 text-[11px] opacity-70">
                    {cat === "全部"
                      ? gossipItems.length
                      : gossipItems.filter((i) => i.category === cat).length}
                  </span>
                </button>
              );
            })}
          </div>
        </Reveal>

        {/* cards */}
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((item, idx) => (
            <Reveal key={item.id} delay={(idx % 3) * 70}>
              <article className="group h-full rounded-xl border border-background-200 bg-background-50 overflow-hidden flex flex-col">
                <div className="w-full h-40 md:h-44 bg-background-100 overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} 话题配图`}
                    title={`夏目彩春 ${item.category} 话题`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-4 md:p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span
                      className={`text-[11px] px-2 py-0.5 rounded-full font-label ${
                        item.category === "已澄清"
                          ? "bg-secondary-100 text-secondary-900"
                          : item.category === "传闻"
                          ? "bg-primary-100 text-primary-700"
                          : item.category === "冷知识"
                          ? "bg-accent-100 text-accent-700"
                          : "bg-primary-100 text-primary-700"
                      }`}
                    >
                      {item.category}
                    </span>
                    <span className="text-[11px] text-foreground-500">{item.date}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                    {item.summary}
                  </p>
                  <div className="mt-4 pt-3 border-t border-background-200 flex items-center gap-3">
                    <span className="text-[11px] text-foreground-500 font-label whitespace-nowrap">
                      讨论热度
                    </span>
                    <div className="flex-1 h-1.5 rounded-full bg-background-200 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-primary-500"
                        style={{ width: `${item.heat}%` }}
                      ></div>
                    </div>
                    <span className="text-[11px] text-foreground-700 font-label">
                      {item.heat}
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="mt-6 text-sm text-foreground-500">该分类下暂无条目。</p>
        )}
      </div>
    </section>
  );
}